import UserCardsReducer from './UserCardsReducer';

export default from './UserCardsContainer';

export const UserCardsReducers = {
  UserCardsReducer,
};
